module.exports = __webpack_public_path__ + "static/media/tem.77eb7859.png";